import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Urls } from '../utilities/urls.component';
import { HttpHeadersService } from './http-headers.service';

@Injectable()
export class PartnerOutageService {

  constructor(private http: HttpClient, private headers: HttpHeadersService) { }

  getAllOutageList(request: any) {
    var url: string = Urls.API_ENDPOINT + Urls.OUTAGE.getAllOutageInfo;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders());
  }

  updateOutageInfo(request: any) {
    var url: string = Urls.API_ENDPOINT + Urls.OUTAGE.updateOutageInfo;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders());
  }
  getPartnerOutageInfo(request: any) {
    var url: string = Urls.API_ENDPOINT + Urls.OUTAGE.partnerOutageInfo;
    return this.http.post(url, request, this.headers.getCommonHttpHeaders());
  }

}
